// lib/settled.ts — the refresh of a write without a form, run on settled (no import of the client itself: a hook
// file pulls this in, a page's test mocks the transport).

import { statusOf } from './refusal.js';

/** The refresh of a write WITHOUT a form — an act, a delete, a toggle, an autosave — run after a success AND after a
 *  refusal (ADR-084 §6: those surfaces reload plainly, so the screen behind a refusal shows what is true; nothing
 *  else re-reads it — no focus refetch). A refusal is the server's own no: a 4xx. Everything else re-reads nothing —
 *  a row GONE (404: its own page, re-read, would send the person to Not found), a BUSY answer (the server is full;
 *  the door said so), a server unreachable or failing (no answer, a 5xx: the re-read would fail the same way and
 *  blank the page behind). The refresh gets the error, null on a success — a delete re-reads the row it spared on
 *  a refusal. A form's hook refreshes on success; its refusal re-reads through Load the latest. */
export function refreshOnSettled<TData, TVars>(refresh: (data: TData | undefined, vars: TVars, error: Error | null) => unknown) {
  return (data: TData | undefined, error: Error | null, vars: TVars): unknown => {
    const status = error === null ? null : statusOf(error);
    const refused = status !== null && status >= 400 && status < 500 && status !== 404;
    return error === null || refused ? refresh(data, vars, error) : undefined;
  };
}
